import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The recommended mixer setup as one drawing: the student's sources into the
 * mixer, the mixer into the computer and Zoom, Russ back through the same
 * mixer to the headphones, and the Record Source switch keeping Russ out of
 * what goes back to Russ. Strokes are currentColor so the page draws it in
 * ink and the greyscale guide draws it in black.
 */
@Component({
  selector: 'app-signal-flow-diagram',
  templateUrl: './signal-flow-diagram.component.html',
  styleUrl: './signal-flow-diagram.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignalFlowDiagramComponent {}
